import {css} from 'lit';
export const styles = css`a {
  --link-text: var(--dark-text);
  --link-text-active: var(--dark-text);
  --link-text-hover: var(--dark-text);

  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  background-color: var(--gray-new-000);
  border-radius: 10px;
}

  a:active {
    background-color: var(--gray-new-200);
  }

bu-icon {
  color: var(--primary-new-400);
}

::slotted(*) {
  margin: 0;
  font-weight: 400;
  font-size: var(--font-size-base);
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

:host([layout='thumb']) a {
    width: 158px;
    height: 158px;
    flex-direction: column;
  }

:host([layout='thumb']) .figure-wrapper {
    position: relative;
  }

:host([layout='thumb']) bu-icon {
    font-size: 74px;
    margin-top: 24px;
    margin-bottom: 16px;
  }

:host([layout='thumb']) img {
    position: absolute;
    width: 40px;
    height: 35px;
    bottom: 8px;
    right: -8px;
    border-radius: 6px;
    border: 1px solid var(--gray-new-100);
  }

:host([layout='thumb']) ::slotted(*) {
    -webkit-line-clamp: 2;
  }

:host([layout='list']) a {
    height: 52px;
  }

:host([layout='list']) bu-icon {
    font-size: 28px;
    margin-right: 16px;
  }

:host([layout='list']) ::slotted(*) {
    flex: 1;
    -webkit-line-clamp: 1;
  }

:host([layout='list']) a.level-inner div {
      flex: 1;
      display: flex;
      align-items: center;
    }

:host([layout='list']) a.level-inner span {
      font-size: var(--font-size-sm);
      color: var(--dark-text-secondary);
    }

@media (max-width: 767px) {
      :host([layout='list']) a.level-inner div {
        flex-wrap: wrap;
      }

        :host([layout='list']) a.level-inner div ::slotted(*) {
          flex-basis: 100%;
        }
        :host([layout='list']) a.level-inner span.owner {
          display: none;
        }

        :host([layout='list']) a.level-inner span.size:not(:empty)::before {
          content: '•';
          margin-left: 4px;
          margin-right: 4px;
        }
    }

@media (min-width: 768px) {

:host([layout='list']) a.level-inner {
      height: 68px;
      border-radius: 0;
      background-color: var(--contrast-light)
  }

      :host([layout='list']) a.level-inner:active {
        background-color: var(--gray-new-000);
      }

      :host([layout='list']) a.level-inner div > span {
        margin-left: 16px;
        flex-basis: 100px;
      }

        :host([layout='list']) a.level-inner div > span:empty::before {
          content: '—';
        }

        :host([layout='list']) a.level-inner div > span.created-at > span {
          display: none;
        }

        :host([layout='list']) a.level-inner div > span.owner {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }

        :host([layout='list']) a.level-inner div > span.size {
          flex-basis: 50px;
        }
    }
`;
export default styles;
